<template>
  <div
    class="call-taker-mode"
    :class="{
      'enabled': userCallTakerModeEnabled,
      'text-muted': !userCallTakerModeEnabled,
    }"
    id="call-taker-mode-tooltip"
    @click="toggleCallTakerMode"
  >
    <b-iconstack v-if="userCallTakerModeEnabled" font-scale="1.5">
      <b-icon stacked icon="headphones" scale="0.7" />
      <b-icon stacked icon="circle" />
    </b-iconstack>
    <b-iconstack v-else font-scale="1.5">
      <b-icon stacked icon="headphones" scale="0.7" />
      <b-icon stacked icon="circle" variant="danger" />
      <b-icon stacked icon="slash" variant="danger" scale="1.5" rotate="90" />
    </b-iconstack>
    <b-popover
      target="call-taker-mode-tooltip"
      triggers="hover"
      placement="bottom"
    >
      {{
        userCallTakerModeEnabled
          ? `Assigned Position: ${userCallTakerPositionObj.sip_id}${!userCallTakerPositionObj.position_name ? '' : ' (' + userCallTakerPositionObj.position_name + ')'}`
          : 'Enable Call Taker Mode'
      }}
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/events/eventBus";
import EnableCallTakerMode from "@/components/conversations/EnableCallTakerMode";

export default {
  name: "CallTakerMode",
  data() {
    return {
      toggling: false,
    };
  },
  computed: {
    ...mapGetters("user", ["currentUser", "userCallTakerModeEnabled", "userCallTakerPosition", "userCallTakerPositionObj"]),
  },
  created() {},
  methods: {
    ...mapActions("user", ["updateCallTakerMode"]),
    async toggleCallTakerMode() {
      try {
        this.toggling = true;
        if (this.userCallTakerModeEnabled) {
          if (!confirm("Are you sure you want to disable Call Taker Mode?")) {
            return;
          }
          await this.$ConveyApi.agenciesApi.unassignUserFromPosition({
            userId: this.currentUser.user_id,
            positionId: this.userCallTakerPosition,
          });
          this.updateCallTakerMode(null);
          this.$toastr("success", "Disabled Call Taker Mode.");
        } else {
          const $ = window.$;
          $("#id-modal-container").modal({
            backdrop: "static"
          });
          EventBus.$emit("open", {
            component: EnableCallTakerMode,
            title: "Enable Call Taker Mode",
            actionButton: "Enable",
            closeOnClick: false,
          });
        }
      } catch(err) {
        console.log("[CallTakerMode:toggleCallTakerMode] ERROR: ", err);
      } finally {
        this.toggling = false;
      }
    }
  },
};
</script>

<style lang="scss">
.call-taker-mode {
  cursor: pointer;

  &.enabled {
    color: #0acc95;
  }
}

.call-taker-mode-tooltip {
  width: max-content !important;
}
</style>